<div class="create-role-wrapper">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0">{{doc.name}}</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()">
            <i class="flaticon-close"></i>
        </button>
    </div>
    <ng-container *ngIf="image; else no_img">
        <div class="p-20" style="height: 90vh; overflow: auto;">
            <img [src]="image" alt="" width="80%">
        </div>
    </ng-container>
    <ng-template #no_img>
        <!-- <ngx-doc-viewer 
            [url]="doc.path" 
            viewer="google" 
            style="width:100%;height:90vh;"
            [googleCheckContentLoaded]="true"
            [googleCheckInterval]="3000"
            [googleMaxChecks]="5"
            (loaded)="contentLoaded()">
        </ngx-doc-viewer> -->

        <!-- <ngx-doc-viewer 
            [viewerUrl]="viewer"
            [url]="doc.path" 
            viewer="url"
            style="width:100%;height:90vh;"
            (loaded)="contentLoaded()">
        </ngx-doc-viewer> -->
    </ng-template>
</div>